module.exports = __webpack_public_path__ + "img/clothing177.9d9286bf.jpg";